import { NEWBUILDING_ADFOX_SITE_JK_DESKTOP } from '../../constants/experiments';
import { TApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';

export const selectBuilderLinkExperimentActive = (state: TApplicationState) => {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_ADFOX_SITE_JK_DESKTOP, 'enabled');
};
